import _toNumber from 'lodash/toNumber';
import _isNaN from 'lodash/isNaN';
import _toString from 'lodash/toString';

export const calculateTotalPounds = (stone, pounds) => {
  if (stone === '' && pounds === '') {
    return '';
  }
  const totalPounds = (_toNumber(stone) * 14) + _toNumber(pounds);
  if (_isNaN(totalPounds)) {
    return '';
  }
  return _toString(totalPounds);
};

export const convertWeightImperialToMetric = (stone, pounds) => {
  if (stone === '' && pounds === '') {
    return '';
  }
  const totalPounds = calculateTotalPounds(stone, pounds);
  if (totalPounds === '') {
    return '';
  }
  return _toString(Math.round(totalPounds / 2.2));
};

export const convertWeightMetricToImperial = kilograms => {
  if (kilograms === '') {
    return { stone: '', pounds: '' };
  }
  const totalPounds = Math.round(_toNumber(kilograms) * 2.2);
  if (_isNaN(totalPounds)) {
    return { stone: '', pounds: '' };
  }
  const stone = _toString(Math.floor(totalPounds / 14));
  const pounds = _toString(totalPounds % 14);
  return { stone, pounds };
};

export const calculateTotalInches = (feet, inches) => {
  if (feet === '' && inches === '') {
    return '';
  }
  const totalInches = (_toNumber(feet) * 12) + _toNumber(inches);
  if (_isNaN(totalInches)) {
    return '';
  }
  return _toString(totalInches);
};

export const convertHeightImperialToMetric = (feet, inches) => {
  if (feet === '' && inches === '') {
    return '';
  }
  const totalInches = calculateTotalInches(feet, inches);
  if (totalInches === '') {
    return '';
  }
  const centimetres = Math.round(totalInches * 2.54);
  return _toString(centimetres);
};

export const convertHeightMetricToImperial = centimetres => {
  if (centimetres === '') {
    return { feet: '', inches: '' };
  }
  const totalInches = Math.round(_toNumber(centimetres) / 2.54);
  if (_isNaN(totalInches)) {
    return { feet: '', inches: '' };
  }
  const feet = _toString(Math.floor(totalInches / 12));
  const inches = _toString(totalInches % 12);
  return { feet, inches };
};
